module.exports = __webpack_public_path__ + "img/m02.9f36f431.png";